export default __webpack_public_path__ + "static/media/DOLL_P3.7e19baff.svg";